export default "__VITE_ASSET__7cd98dd9__"